import React, { useContext, useEffect, useRef, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import config from "../../config";
import { GlobalContext } from "../../global/GlobalProvider";
import { useNavigate } from "react-router";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { useTranslation } from "react-i18next";

export default function MyBets() {
  const { t, i18n } = useTranslation();
  const initialized = useRef(false);
  const token = sessionStorage.getItem("token");
  const [betDetails, setBetDetails] = useState([]);
  const [sportsArray, setSportsArray] = useState([]);
  const [casinoArray, setCasinoArray] = useState([]);
  const [activeTab, setActiveTab] = useState('sport');

  const [totalBetsCount, setTotalBetsCount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const navigate = useNavigate();
  const { loggedIn } = useContext(GlobalContext);
  const [searchText, setSearchText] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    const storedValue = sessionStorage.getItem('loggedIn');
    return storedValue === "true";
  });

  useEffect(() => {
    // if(!isLoggedIn || loggedIn){
    //     navigate('/')
    // }
  }, [isLoggedIn, loggedIn])

  const [selectedFilter, setSelectedFilter] = useState("ALL");
  const [isMatched, setIsMatched] = useState("OPEN");

  const [casinoItemsPerPage, setCasinoItemsPerPage] = useState(10);
  const [casinoCurrentPage, setCasinoCurrentPage] = useState(1);

  const [sportItemsPerPage, setSportItemsPerPage] = useState(10);
  const [sportCurrentPage, setSportCurrentPage] = useState(1);

  const data = activeTab === "casino" ? casinoArray : sportsArray;

  const filteredData = data
    .filter((item) => selectedFilter === "ALL" || item.bettype2 === selectedFilter)
    .filter((item) => item.status === isMatched)
    .filter((item) =>
      searchText
        ? [item.userName, item.betType, item.match, item.marketName, item.oddValue.toString(), item.Stake.toString()]
          .some((field) => field?.toLowerCase().includes(searchText.toLowerCase()))
        : true
    );

  const itemsPerPage = activeTab === "casino" ? casinoItemsPerPage : sportItemsPerPage;
  const currentPage = activeTab === "casino" ? casinoCurrentPage : sportCurrentPage;
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  useEffect(() => {
    if (activeTab === "casino") setCasinoCurrentPage(1);
    else setSportCurrentPage(1);
  }, [activeTab, casinoItemsPerPage, sportItemsPerPage]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const firstPage = () => activeTab === "casino" ? setCasinoCurrentPage(1) : setSportCurrentPage(1);
  const lastPage = () => activeTab === "casino" ? setCasinoCurrentPage(totalPages) : setSportCurrentPage(totalPages);
  const nextPage = () => activeTab === "casino"
    ? setCasinoCurrentPage((prev) => Math.min(prev + 1, totalPages))
    : setSportCurrentPage((prev) => Math.min(prev + 1, totalPages));
  const prevPage = () => activeTab === "casino"
    ? setCasinoCurrentPage((prev) => Math.max(prev - 1, 1))
    : setSportCurrentPage((prev) => Math.max(prev - 1, 1));
  const goToPage = (page) => activeTab === "casino" ? setCasinoCurrentPage(page) : setSportCurrentPage(page);


  const callMyBets = (fromDate, toDate, page) => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow"
    };

    fetch(`${process.env.REACT_APP_BASE_URL}/api/v1/Account/getBetDetails2`, requestOptions)
      .then(async (response) => {
        let paresData = await response.json();
        setTotalAmount(paresData?.data?.amount);
        setTotalBetsCount(paresData?.data?.count);
        setSportsArray(paresData?.mybets?.sport)
        setCasinoArray(paresData?.mybets?.casino)
      })
      .catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      callMyBets('', '', currentPage);
    }
  });

  const formatDatefromAPI = (isoDate) => {
    const date = new Date(isoDate);

    // Get date components
    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getUTCFullYear();

    // Get time components in UTC+05:30 (Indian Standard Time)
    const options = { timeZone: "Asia/Kolkata", hour12: false };
    const timeString = date.toLocaleTimeString("en-GB", options); // 24-hour format HH:mm:ss

    // Get the UTC offset (+05:30)
    const offset = date.getTimezoneOffset(); // Returns offset in minutes
    const offsetHours = String(Math.abs(offset) / 60).padStart(2, "0");
    const offsetMinutes = String(Math.abs(offset) % 60).padStart(2, "0");
    const offsetSign = offset > 0 ? "-" : "+";

    return `${day}/${month}/${year} ${timeString} (UTC${offsetSign}${offsetHours}:${offsetMinutes})`;
  };

  const pageReset = () => {
    setCasinoCurrentPage(1);
    setSportCurrentPage(1);
  }

  const generateCSV = () => {
    // Convert data to CSV format

    const headers = "Sports,Event Name,Market Name,Nation,User Rate,Amount,Place Date\n";
    const rows = currentItems.map(item =>
      `${item.betType},
            ${item.match},
            ${item.marketName},
            ${item.selectionName},
            ${item.oddValue},
            ${item.Stake.toFixed(2)},
            ${formatDatefromAPI(item.date)}
                `).join("\n");

    // Create Blob and download
    let name = `MyBets_${Date.now()}.csv`
    const csvContent = "data:text/csv;charset=utf-8," + headers + rows;
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", name);
    document.body.appendChild(link);
    link.click();
  };

  const generatePDF = () => {
    const doc = new jsPDF();



    const headers = [["Sports", "Event Name", "Market Name", "Nation", "User Rate", "Amount", "Place Date"]];

    // Map Data to Table Format
    const tableData = currentItems.map((item) =>
      [
        item.betType,
        item.match,
        item.marketName,
        item.selectionName,
        item.oddValue,
        item.Stake.toFixed(2),
        formatDatefromAPI(item.date)
      ]);

    // Use autoTable with Proper Import
    autoTable(doc, {
      head: headers,
      body: tableData,
      startY: 20, // Start position in PDF
    });

    // Save PDF
    doc.save(`MyBets_${Date.now()}.pdf`);
  };

  const totalSum = () =>{
    return filteredData.reduce((sum, item) => sum + item.Stake, 0).toFixed(2);
  }

  return (
    <div className="content-box">
      <div className="report-box">
        <div className="report-title">
          <div className="report-name">{t('Current Bets')}</div>
          <div className="report-search search-box">
            <div className="form-group mb-0">
              <input type="text" placeholder={t("search")} className="form-control" value={searchText} onChange={(e) => setSearchText(e.target.value)} />
              <img src="https://wver.sprintstaticdata.com/v111/static/front/img/search.svg" className="search-icon" />
            </div>
          </div>
        </div>
        <div className="casino-report-tabs">
          <ul className="nav nav-tabs">
            <li className="nav-item">
              <span data-toggle="tab" onClick={() => setActiveTab("sport")} className={`nav-link ${activeTab === "sport" ? 'active' : ''}`}>{t('Sports')}</span>
            </li>
            <li className="nav-item">
              <span data-toggle="tab" onClick={() => setActiveTab("casino")} className={`nav-link ${activeTab === "casino" ? 'active' : ''}`}>{t('Casino')}</span>
            </li>
          </ul>
        </div>
        <div className="report-form">
          <div className="custom-control custom-radio custom-control-inline">
            <input type="radio" id="customRadio" name="example" checked={isMatched === "OPEN"} onChange={() => (setIsMatched("OPEN"), pageReset())} className="custom-control-input" />
            <label htmlFor="customRadio" className="custom-control-label">{t('Matched')}</label>
          </div>
          <div className="custom-control custom-radio custom-control-inline">
            <input type="radio" id="customRadio2" name="example" checked={isMatched === "CANCEL"} onChange={() => (setIsMatched("CANCEL"), pageReset())} className="custom-control-input" />
            <label htmlFor="customRadio2" className="custom-control-label">{t("Deleted")}</label>
          </div>
        </div>
        <div className="report-page-count">
          <div className="form-group mb-0">
            <label>{t('Show')}</label>
            <select className="form-control" value={activeTab === "casino" ? casinoItemsPerPage : sportItemsPerPage} onChange={(e) => activeTab === "casino" ? setCasinoItemsPerPage(Number(e.target.value)) : setSportItemsPerPage(Number(e.target.value))} >
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="200">200</option>
              <option value="300">300</option>
              <option value="400">400</option>
              <option value="500">500</option>
            </select>
            <label>{t('Entries')}</label>
          </div>
          <div className="bet-types-container">
            <div className="custom-control custom-radio custom-control-inline">
              <input type="radio" id="soda-all" name="betType" className="custom-control-input" value="ALL" checked={selectedFilter === "ALL"} onChange={() => (setSelectedFilter("ALL"), pageReset())} />
              <label htmlFor="soda-all" className="custom-control-label">All</label>
            </div>
            <div className="custom-control custom-radio custom-control-inline">
              <input type="radio" id="soda-back" name="betType" value="BACK" checked={selectedFilter === "BACK"} onChange={() => (setSelectedFilter("BACK"), pageReset())} className="custom-control-input" />
              <label htmlFor="soda-back" className="custom-control-label">Back</label>
            </div>
            <div className="custom-control custom-radio custom-control-inline">
              <input type="radio" id="soda-lay" name="betType" value="LAY" checked={selectedFilter === "LAY"} onChange={() => (setSelectedFilter("LAY"), pageReset())} className="custom-control-input" />
              <label htmlFor="soda-lay" className="custom-control-label">Lay</label>
            </div>
          </div>
          <div className="custom-control-inline">
            <div>{t('Total Bets')} <span className="mr-2">{`${filteredData.length}`}</span> {t('Total Amount')} <strong className={`${totalSum() > 0 ? 'green-txt' : 'red-txt'}`}>{`${totalSum()}`}</strong></div>
          </div>
          <div className="file-icons">
            <div className="icon" onClick={generatePDF}>
              <i className={`fas fa-file-pdf ${currentItems.length > 0 ? '' : 'disabled'}`}></i>
            </div>
            <div className="icon" onClick={generateCSV}>
              <i className={`fas fa-file-excel ${currentItems.length > 0 ? '' : 'disabled'}`}></i>
            </div>
          </div>
        </div>
        <div className="report-table current-bets table-responsive">
          <table className="table table-hover">
            <thead>
              <tr>
                <th className="bet-sport">{t('Sports')}</th>
                <th className="bet-event-name">{t('Event Name')}</th>
                <th className="bet-nation">{t('Market Name')}</th>
                <th className="bet-market-name">{t('Nation')}</th>
                <th className="text-right bet-user-rate">{t('User Rate')}</th>
                <th className="text-right bet-amount">{t('Amount')}</th>
                <th className="bet-date">{t('Place Date')}</th>
              </tr>
            </thead>
            <tbody>
              {currentItems.length > 0 ? (
                currentItems.map((item, index) => (
                  <tr key={index} className={`${item.bettype2 === 'BACK' ? 'back' : 'lay'}-border`}>
                    <td className="bet-sport"><div>{item.betType}</div></td>
                    <td className="bet-event-name"><div className="ifTooltip">{item.match}</div></td>
                    <td className="bet-nation"><div className="ifTooltip">{item.marketName}</div></td>
                    <td className="bet-market-name"><div className="ifTooltip">{item.selectionName}</div></td>
                    <td className="text-right bet-user-rate"><div>{item.oddValue}</div></td>
                    <td className="text-right bet-amount"><div>{item.Stake}</div></td>
                    <td className="bet-date"><div>{formatDatefromAPI(item.date)}</div></td>
                   
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9">{t('No results found')}</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {currentItems.length > 0 ? <ul className="pagination justify-content-center mt-2">
          <li className="page-item disabled" onClick={firstPage} disabled={currentPage === 1}>
            <a tabindex="-1" className="page-link">&lt;&lt;</a>
          </li>
          <li className="page-item disabled" onClick={prevPage} disabled={currentPage === 1}>
            <a tabindex="-1" className="page-link">&lt;</a>
          </li>
          {Array.from({ length: totalPages }, (_, i) => (
            <li className={`page-item ${currentPage === i + 1 ? 'active' : ''}`} key={i} onClick={() => goToPage(i + 1)} style={{ fontWeight: currentPage === i + 1 ? "bold" : "normal" }}>
              <a tabindex="0" className="page-link"> {i + 1}</a>
            </li>
          ))}
          <li className="page-item disabled" onClick={nextPage} disabled={currentPage === totalPages}>
            <a tabindex="-1" className="page-link">&gt;</a>
          </li>
          <li className="page-item disabled" onClick={lastPage} disabled={currentPage === totalPages}>
            <a tabindex="-1" className="page-link">&gt;&gt;</a>
          </li>
        </ul> : ''}
      </div>
    </div>
  );
}
